export const Partners = () => {
  return (
    <div>
      <h2>Partners Page</h2>
      <p>Some account information here</p>
    </div>
  );
};
